
import DefaultNavbar from '@/components/default-layout/DefaultNavbar.vue';
import DefaultSidebar from '@/components/default-layout/DefaultSidebar.vue';
import DefaultSidebarDesktop from '@/components/default-layout/DefaultSidebarDesktop.vue';
import DefaultSidebarMobile from '@/components/default-layout/DefaultSidebarMobile.vue';
import ImpersonationBanner from '@/components/default-layout/ImpersonationBanner.vue';
import NotificationContainer from '@/components/ui/NotificationContainer.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'default-layout',
  components: {
    NotificationContainer,
    DefaultSidebarMobile,
    DefaultSidebarDesktop,
    DefaultSidebar,
    DefaultNavbar,
    ImpersonationBanner,
  },
})
export default class DefaultLayout extends Vue {
  showMobileSidebar = false;

  get showSidebarToggle(): boolean {
    const name = this.$route.name || '';
    return name.startsWith('project') || name.startsWith('chain');
  }

  get fullWidthContent(): boolean {
    return !!this.$route.meta?.fullWidth;
  }
}
